/* eslint-disable max-len */
const React = require('react');
const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');
const { creditCardPaymentTypes, debitCardPaymentTypes } = require('./constants');
const { CountryOfOperationItems } = require('../utils/constants');

const defaultAdvancedColorsOptions = {
  buttonBackground: '',
  buttonHeight: '',
  borderRadius: '',
  valuePropColor: '',
  verticalPadding: '',
  horizontalPadding: '',
  theme: {
    elementsColor: '',
    headerColor: '',
  },
};

const defaultAdvancedTextOptions = {
  action: '',
  valueProp: '',
};

const defaultInitializationOptions = {
  back_urls: {
    success: '',
    pending: '',
    failure: '',
  },
  auto_return: '',
  initialization: {
    redirectMode: '',
  },
};

function componentProps(i18n, lang) {
  return {
    title: i18n.gettext('Checkout Pro'),
    description: i18n.gettext('Construye la experiencia visual de Checkout Pro en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregar a tu sitio o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Pro'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-pro/overview`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '3',
        disabled: true,
      },
    ],
    publicKey: 'APP_USR-7355677e-d3ce-43d8-89bf-99a4c74718ca',
    optionsDescription: i18n.gettext('Configuraciones básicas'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es',
      },
      {
        description: i18n.gettext('English'),
        value: 'en',
      },
    ],
    options: [
      {
        id: 'publicKey',
        type: 'dropdown',
        label: i18n.gettext('País de operación'),
        placeholder: i18n.gettext('País de operación'),
        trackingLabel: 'COUNTRY_OF_OPERATION',
        items: CountryOfOperationItems.getJsxItems(i18n),
        width: 'full',
      },
      {
        id: 'PaymentTypeLabel',
        type: 'label',
        // paliative pt translation
        label: lang === 'pt' ? i18n.gettext('Desative os meios de pagamento que não deseja oferecer:') : i18n.gettext('Desactiva los medios de pago que no quieres ofrecer:'),
        tooltipContent: lang === 'pt' ? i18n.gettext('O Checkout Pro vem configurado com todos os meios de pagamento habilitados. Você pode desativar aquelas que não deseja oferecer.') : i18n.gettext('El Checkout Pro viene configurado con todos los medios de pago habilitados. Puedes desactivar aquellos que no quieres ofrecer.'),
      },
      {
        id: 'credit_card',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Tarjeta de crédito'),
        trackingLabel: 'PAYMENT_METHOD_CREDIT_CARD',
      },
      {
        id: 'PaymentTypeCreditCardLabel',
        type: 'label',
        // paliative pt translation
        label: lang === 'pt' ? i18n.gettext('Selecione as bandeiras de cartão que deseja oferecer:') : i18n.gettext('Selecciona las tarjetas que quieres ofrecer:'),
        style: {
          paddingLeft: '20px',
        },
        conditionalRender: [
          {
            inputId: 'credit_card',
            expectedValue: true,
          },
        ],
      },
      {
        id: 'paymentMethodCreditCardType',
        type: 'checkboxList',
        width: 'full',
        // paliative pt translation
        label: lang === 'pt' ? i18n.gettext('Selecione as bandeiras de cartão que deseja ativar:') : i18n.gettext('Selecciona las tarjetas que quieres activar:'),
        trackingLabel: 'PAYMENT_METHOD_CREDIT_CARD_TYPES',
        defaultValue: creditCardPaymentTypes,
        style: {
          marginTop: '-20px',
          paddingLeft: '20px',
        },
        conditionalRender: [
          {
            inputId: 'credit_card',
            expectedValue: true,
          },
        ],
        items: [
          {
            id: 'amex',
            title: i18n.gettext('American Express'),
            value: 'amex',
          },
          {
            id: 'elo',
            title: i18n.gettext('Elo'),
            value: 'elo',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
              },
            ],
          },
          {
            id: 'hipercard',
            title: i18n.gettext('Hipercard'),
            value: 'hipercard',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
              },
            ],
          },
          {
            id: 'master',
            title: i18n.gettext('Mastercard'),
            value: 'master',
          },
          {
            id: 'visa',
            title: i18n.gettext('Visa'),
            value: 'visa',
          },
          // Specific argentinian credit cards
          {
            id: 'argencard',
            title: i18n.gettext('Argencard'),
            value: 'argencard',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'cabal',
            title: i18n.gettext('Cabal'),
            value: 'cabal',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'cmr',
            title: i18n.gettext('CMR'),
            value: 'cmr',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'cencosud',
            title: i18n.gettext('CentroCosto'),
            value: 'cencosud',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'cordobesa',
            title: i18n.gettext('Cordobesa'),
            value: 'cordobesa',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'diners',
            title: i18n.gettext('Diners'),
            value: 'diners',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: [
                  'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
                  'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC key
                ],
              },
            ],
          },
          {
            id: 'naranja',
            title: i18n.gettext('Naranja'),
            value: 'naranja',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'tarshop',
            title: i18n.gettext('Tarjeta Shopping'),
            value: 'tarshop',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          // Specific colombian credit cards
          {
            id: 'codensa',
            title: i18n.gettext('Crédito Fácil Codensa'),
            value: 'codensa',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              },
            ],
          },
          // Specific uruguayan credit cards
          {
            id: 'creditel',
            title: i18n.gettext('Creditel'),
            value: 'creditel',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
              },
            ],
          },
          {
            id: 'oca',
            title: i18n.gettext('OCA'),
            value: 'oca',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
              },
            ],
          },
        ],
      },
      {
        id: 'maxInstallments',
        type: 'dropdown',
        label: i18n.gettext('Número máximo de cuotas'),
        placeholder: i18n.gettext('Número máximo de cuotas'),
        message: i18n.gettext('Válido solo para pagos con tarjeta de crédito'),
        trackingLabel: 'MAXIMUM_NUMBER_OF_INSTALLMENTS',
        defaultValue: 1,
        width: '170',
        style: {
          paddingLeft: '20px',
          marginBottom: '18px',
        },
        conditionalRender: [
          {
            inputId: 'credit_card',
            expectedValue: true,
          },
        ],
        items: [
          { value: 1, primary: `1 ${i18n.gettext('cuota')}` },
          { value: 2, primary: `2 ${i18n.gettext('cuotas')}` },
          { value: 3, primary: `3 ${i18n.gettext('cuotas')}` },
          { value: 4, primary: `4 ${i18n.gettext('cuotas')}` },
          { value: 5, primary: `5 ${i18n.gettext('cuotas')}` },
          { value: 6, primary: `6 ${i18n.gettext('cuotas')}` },
          { value: 7, primary: `7 ${i18n.gettext('cuotas')}` },
          { value: 8, primary: `8 ${i18n.gettext('cuotas')}` },
          { value: 9, primary: `9 ${i18n.gettext('cuotas')}` },
          { value: 10, primary: `10 ${i18n.gettext('cuotas')}` },
          { value: 11, primary: `11 ${i18n.gettext('cuotas')}` },
          { value: 12, primary: `12 ${i18n.gettext('cuotas')}` },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      // Specific brazilian payment methods
      {
        id: 'pix',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Pix'),
        trackingLabel: 'PAYMENT_METHOD_PIX',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        id: 'bolbradesco',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Cupón de pago'),
        trackingLabel: 'PAYMENT_METHOD_BOLETO',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        id: 'debit_card_caixa',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Cartão de débito virtual caixa'),
        trackingLabel: 'PAYMENT_METHOD_CAIXA_VIRTUAL_DEBIT_CARD',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      {
        id: 'pec',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Pagamento na lotérica'),
        trackingLabel: 'PAYMENT_METHOD_PEC',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB key
          },
        ],
      },
      // Specific argentinian payment methods
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC key
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
      },
      {
        id: 'debit_card',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Tarjeta de débito'),
        trackingLabel: 'PAYMENT_METHOD_DEBIT_CARD',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC key
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
      },
      {
        id: 'paymentMethodDebitCardTypeLabel',
        type: 'label',
        label: lang === 'pt' ? i18n.gettext('Selecione as bandeiras de cartão que deseja ativar:') : i18n.gettext('Selecciona las tarjetas que quieres activar:'),
        conditionalRender: [
          {
            inputId: 'debit_card',
            expectedValue: true,
          },
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC key
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
      },
      {
        id: 'paymentMethodDebitCardType',
        type: 'checkboxList',
        width: 'full',
        trackingLabel: 'PAYMENT_METHOD_DEBIT_CARD_TYPES',
        style: {
          marginTop: '-20px',
          paddingLeft: '20px',
        },
        defaultValue: debitCardPaymentTypes,
        conditionalRender: [
          {
            inputId: 'debit_card',
            expectedValue: true,
          },
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC key
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
        items: [
          {
            id: 'debcabal',
            title: i18n.gettext('Cabal'),
            value: 'debcabal',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'maestro',
            title: i18n.gettext('Maestro'),
            value: 'maestro',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key
              },
            ],
          },
          {
            id: 'debmaster',
            title: i18n.gettext('Mastercard'),
            value: 'debmaster',
          },
          {
            id: 'debvisa',
            title: i18n.gettext('Visa'),
            value: 'debvisa',
          },
          {
            id: 'redcompra',
            title: i18n.gettext('RedCompra'),
            value: 'redcompra',
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLC key
              },
            ],
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key,
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
            ],
          },
        ],
      },
      {
        id: 'ticket',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Efectivo'),
        trackingLabel: 'PAYMENT_METHOD_DEBIT_CARD_EFECTIVO',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA key,
              'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
            ],
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
          },
        ],
      },
      {
        id: 'bank_transfer',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Transferencia SPEI'),
        trackingLabel: 'PAYMENT_METHOD_ELECTRONIC_TRANSFER',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM key
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
      },
      {
        id: 'ticket',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Ticket'),
        trackingLabel: 'PAYMENT_METHOD_TICKET',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: [
              'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO key
              'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU key
            ],
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
          },
        ],
      },
      {
        id: 'pagoefectivo_atm',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Efectivo en agentes'),
        trackingLabel: 'PAYMENT_METHOD_EFECTIVO_AGENTES',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
          },
        ],
      },
      {
        type: 'divider',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
          },
        ],
      },
      {
        id: 'bancaInternet',
        type: 'switch',
        width: 'full',
        defaultValue: true,
        label: i18n.gettext('Banca por internet'),
        trackingLabel: 'PAYMENT_METHOD_BANCA_INTERNET',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE key
          },
        ],
      },
    ],
  };
}

function getProps(i18n, lang) {
  return componentProps(i18n, lang);
}

module.exports = { getProps, defaultAdvancedColorsOptions, defaultAdvancedTextOptions, defaultInitializationOptions };
